import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

// Cấu hình Firebase từ Project của bạn
const firebaseConfig = {
  apiKey: "AIzaSyAJnVSLj3iu_uTr5Lt8I_7LRmEXVPv8CQ4",
  authDomain: "signalviet-19fbe.firebaseapp.com",
  projectId: "signalviet-19fbe",
  storageBucket: "signalviet-19fbe.firebasestorage.app",
  messagingSenderId: "436825427774",
  appId: "1:436825427774:web:400b229d509b020b9f666f",
  measurementId: "G-2YK3VWP2YV"
};

// Khởi tạo Firebase App
const app = initializeApp(firebaseConfig);

// Khởi tạo Analytics (theo dõi truy cập)
const analytics = getAnalytics(app);

// Quan trọng: Xuất biến dbFirestore để file database.ts sử dụng
export const dbFirestore = getFirestore(app);
